var map = {
	"./_borders.less": 63994,
	"./_colors.less": 47469,
	"./_commons.less": 11771,
	"./_fonts.less": 98623,
	"./_imports.less": 22095,
	"./_mediaqueries.less": 71701,
	"./_mixins.less": 88779,
	"./_sizes.less": 67363,
	"./_utils.less": 97524,
	"./animations.less": 75053,
	"./app.less": 90767,
	"./button-tip.less": 44234,
	"./checkboxgroup.less": 40464,
	"./colums.less": 98595,
	"./commonPopup.less": 18345,
	"./components/componentAudio.less": 48074,
	"./components/componentDropzone.less": 85357,
	"./components/componentHotspot.less": 29367,
	"./components/componentImage.less": 76953,
	"./components/componentSettings.less": 57875,
	"./components/componentSpinner.less": 58142,
	"./components/componentSymbol.less": 61030,
	"./components/componentTable.less": 65444,
	"./components/componentText.less": 24253,
	"./components/componentTimer.less": 71417,
	"./components/componentTrafficlight.less": 38573,
	"./components/components.less": 39057,
	"./components/videocomponent.less": 20727,
	"./contentItemButton.less": 18538,
	"./contentType.less": 5129,
	"./contentTypes/dragQuestion.less": 2937,
	"./contentTypes/dragQuestionDefinitions.less": 39267,
	"./contentTypes/interactiveQuestionDefinitions.less": 52817,
	"./contentTypes/maps.less": 69908,
	"./contentTypes/openQuestion.less": 14311,
	"./contentTypes/openQuestionDefinitions.less": 97129,
	"./contentTypes/poll.less": 1046,
	"./contentTypes/pollDefinitions.less": 20018,
	"./contentTypes/question.less": 96655,
	"./contentTypes/questionDefinitions.less": 77985,
	"./contentTypes/site.less": 53968,
	"./contentTypes/slide-definitions.less": 46541,
	"./contentTypes/slide.less": 61290,
	"./contentTypes/weblink.less": 67285,
	"./contentTypes/wordweb.less": 17305,
	"./contentTypes/wordwebDefinitions.less": 2115,
	"./dragQuestionComponentStyles.less": 86591,
	"./elements.less": 99571,
	"./emoji.less": 60654,
	"./icons-mixin.less": 87498,
	"./icons.less": 1642,
	"./images-mixin.less": 67056,
	"./message.less": 21211,
	"./miniaudioplayer.less": 6766,
	"./player.less": 50363,
	"./playerPin.less": 19628,
	"./slideNoteShared.less": 95976,
	"./smallspinner.less": 68986,
	"./spacing.less": 20461,
	"./table.less": 4688,
	"./thumbPreview.less": 25018,
	"./toast.less": 30147,
	"./util.less": 25478,
	"./video.less": 93351,
	"./videocontroler.less": 56589,
	"./wobble.less": 74847
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5159;